export const specialServiceLabel = {
	hiabRequired: "Hiab Required",
	handLoadUnloadRequired: "Hand Load / Unload Required",
	residentialPickUpDeliveryRequired: "Residential Required",
	ruralPickUpDeliveryRequired: "Rural Required",
	tailLiftPickUpDeliveryRequired: "Tail Lift Required",
	dangerousGoodPickUpDeliveryRequired: "Dangerous Good Required"
} as const;
